<template>
  <div class="home-portal-wrapper">
    <div class="home-portal-card sci-card">
      <div class="portal-logo-container">
        <img alt="myMenu logo" class="portal-logo" src="../assets/logo.png">
      </div>

      <h1 class="portal-title">myMenu</h1>
      <p class="portal-subtitle">Piattaforma di Gestione Sala, Comande & Menù Digitale</p>

      <div class="portal-actions">
        <router-link to="/login" class="sci-btn sci-btn-primary portal-btn">
          <i class="fas fa-sign-in-alt me-2"></i>
          <span>Accedi al Gestionale</span>
        </router-link>

        <router-link to="/client" class="sci-btn sci-btn-secondary portal-btn">
          <i class="fas fa-book-open me-2"></i>
          <span>Menù Digitale Clienti</span>
        </router-link>
      </div>

      <div class="portal-footer">
        <span class="portal-badge">
          <span class="pulse-dot"></span>
          Sistema Attivo • Versione 2.0
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    setTavolo() {
      if (window.location.hash) {
        localStorage.setItem('tavolo', JSON.stringify(window.location.hash));
      }
    }
  },
  beforeMount() {
    this.setTavolo();
  }
}
</script>

<style scoped>
.home-portal-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: radial-gradient(circle at 50% 20%, #ffffff 0%, var(--sci-bg, #f8fafc) 100%);
  box-sizing: border-box;
}

.home-portal-card {
  width: 100%;
  max-width: 480px;
  padding: 48px 36px;
  border-radius: var(--radius-xl, 24px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.08);
  border: 1px solid var(--sci-border, #e2e8f0);
  background: #ffffff;
}

.portal-logo-container {
  margin-bottom: 24px;
  position: relative;
}

.portal-logo {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
  padding: 4px;
  background: #ffffff;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.portal-logo:hover {
  transform: scale(1.04);
}

.portal-title {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--sci-text-main, #0f172a);
  margin: 0 0 8px;
}

.portal-subtitle {
  font-size: 14.5px;
  color: #64748b;
  margin: 0 0 32px;
  max-width: 340px;
  line-height: 1.45;
}

.portal-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.portal-btn {
  width: 100%;
  min-height: 48px;
  font-size: 15px;
  justify-content: center;
}

.portal-footer {
  border-top: 1px solid var(--sci-border, #e2e8f0);
  padding-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.portal-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  background: var(--sci-bg-subtle, #f1f5f9);
  padding: 4px 12px;
  border-radius: 9999px;
}

.pulse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--sci-emerald, #059669);
  box-shadow: 0 0 6px rgba(5, 150, 105, 0.6);
}
</style>
